import { Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth-guard';
import { RoleGuard } from 'app/guards/role-guard';

// Define routes specific to the RD Manager role
export const odManagerRoutes: Routes = [
  {
    path: 'dashboard',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/OD-Manager/od-dashboard/od-dashboard').then(
        (m) => m.OdDashboard,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'OD Manager',
    },
  },
  {
    path: 'project-management',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/RD-Manager/project-management/project-management').then(
        (m) => m.ProjectManagement,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'OD Manager',
    },
  },
  {
    path: 'project-management/add-project',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/RD-Manager/project-management/add-project/add-project').then(
        (m) => m.AddProject,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'OD Manager',
    },
  },
  {
    path: 'project-management/add-project/:id',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/RD-Manager/project-management/add-project/add-project').then(
        (m) => m.AddProject,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'OD Manager',
    },
  },
  {
    path: 'project-management/details/:id',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/RD-Manager/project-management/project-details/project-details').then(
        (m) => m.ProjectDetails,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'OD Manager',
    },
  },
  {
    path: 'data-sync',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/supervisor/data-sync/data-sync').then((m) => m.DataSync),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'OD Manager',
    },
  },
  {
    path: 'resource-management',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/storekeeper/resource-management/resource-management').then(
        (m) => m.ResourceManagement,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'OD Manager',
    },
  },

  {
    path: 'resource-management/add-device/:id',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/storekeeper/resource-management/add-device/add-device').then(
        (m) => m.AddDevice,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'OD Manager',
    },
  },
  {
    path: 'resource-management/add-device',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/storekeeper/resource-management/add-device/add-device').then(
        (m) => m.AddDevice,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'OD Manager',
    },
  },
  {
    path: 'resource-management/device-bulk-upload',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/storekeeper/resource-management/device-bulk-upload/device-bulk-upload').then(
        (m) => m.DeviceBulkUpload,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'OD Manager',
    },
  },
  {
    //pass id in route
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    path: 'resource-management/device-details/:id',
    loadComponent: () =>
      import('@pages/storekeeper/resource-management/device-details/device-details').then(
        (m) => m.DeviceDetails,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'OD Manager',
    },
  },
  {
    path: 'request-management',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/storekeeper/request-management/request-management').then(
        (m) => m.RequestManagement,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'OD Manager',
    },
  },
];
